(function() {
  var body = document.body;
  if (!body || body.getAttribute('data-zen-home-v2-preview') !== 'true') {
    return;
  }

  document.documentElement.classList.add('js-zen-home-v2');

  var reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var syncDecorativeVideos = function() {
    var shouldReduceMotion = reducedMotionQuery && reducedMotionQuery.matches;
    var videos = document.querySelectorAll('.zen-home-v2 video[autoplay]');

    videos.forEach(function(video) {
      if (shouldReduceMotion) {
        video.pause();
        video.removeAttribute('autoplay');
      } else if (video.paused && video.muted) {
        var playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(function() {});
        }
      }
    });
  };

  syncDecorativeVideos();
  if (reducedMotionQuery) {
    if (typeof reducedMotionQuery.addEventListener === 'function') {
      reducedMotionQuery.addEventListener('change', syncDecorativeVideos);
    } else if (typeof reducedMotionQuery.addListener === 'function') {
      reducedMotionQuery.addListener(syncDecorativeVideos);
    }
  }

  var animatedSelectors = [
    '.zen-home-v2-hero__heading[data-zen-home-v2-animate]',
    '.zen-home-v2-hero__subheading[data-zen-home-v2-animate]',
    '.zen-home-v2-hero__actions[data-zen-home-v2-animate]',
    '.zen-home-v2-featured__label--above[data-zen-home-v2-animate]',
    '.zen-home-v2-drop-slider[data-zen-home-v2-animate]',
    '.zen-home-v2-journal-online[data-zen-home-v2-animate]',
    '.zen-home-v2-online__included[data-zen-home-v2-animate]',
    '.zen-home-v2-journal-card--featured[data-zen-home-v2-animate]',
    '.zen-home-v2-journal__rail-heading[data-zen-home-v2-animate]',
    '.zen-home-v2-concept__media-panel[data-zen-home-v2-animate]',
    '.zen-home-v2-concept__intro[data-zen-home-v2-animate]',
    '.zen-home-v2-routing__header[data-zen-home-v2-animate]',
    '.zen-home-v2-waitlist__copy[data-zen-home-v2-animate]',
    '.zen-home-v2-waitlist__form[data-zen-home-v2-animate]'
  ];
  var animated = document.querySelectorAll(animatedSelectors.join(','));
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    animated.forEach(function(el) {
      observer.observe(el);
    });
  } else {
    animated.forEach(function(el) {
      el.classList.add('is-visible');
    });
  }

  var sliders = document.querySelectorAll('[data-zen-home-v2-drop-slider]');
  sliders.forEach(function(slider) {
    var track = slider.querySelector('[data-zen-home-v2-drop-track]');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-zen-home-v2-drop-slide]'));
    var notches = Array.prototype.slice.call(slider.querySelectorAll('[data-zen-home-v2-drop-notch]'));
    var prevButton = slider.querySelector('[data-zen-home-v2-drop-prev]');
    var nextButton = slider.querySelector('[data-zen-home-v2-drop-next]');
    var status = slider.querySelector('[data-zen-home-v2-drop-status]');
    var lightboxTriggers = Array.prototype.slice.call(slider.querySelectorAll('[data-zen-home-v2-drop-lightbox-trigger]'));
    var activeIndex = 0;
    var pointerStartX = null;
    var pointerStartY = null;
    var didHorizontalSwipe = false;
    var focusableSelector = 'a, button, input, select, textarea, [tabindex]';

    var openLightbox = function(trigger) {
      var photoSwipeElement = document.querySelector('.pswp');
      var triggerIndex = lightboxTriggers.indexOf(trigger);
      var shouldReduceMotion = reducedMotionQuery && reducedMotionQuery.matches;

      if (!photoSwipeElement || typeof window.PhotoSwipe !== 'function' || typeof window.PhotoSwipeUI_Default !== 'function') {
        window.location.href = trigger.getAttribute('data-zen-home-v2-lightbox-src');
        return;
      }

      var items = lightboxTriggers.map(function(lightboxTrigger) {
        var thumbnail = lightboxTrigger.querySelector('img');

        return {
          el: lightboxTrigger,
          msrc: thumbnail ? (thumbnail.currentSrc || thumbnail.src) : '',
          src: lightboxTrigger.getAttribute('data-zen-home-v2-lightbox-src'),
          w: parseInt(lightboxTrigger.getAttribute('data-zen-home-v2-lightbox-width'), 10),
          h: parseInt(lightboxTrigger.getAttribute('data-zen-home-v2-lightbox-height'), 10)
        };
      });
      var lightboxUi = photoSwipeElement.querySelector('.pswp__ui');
      var lightboxCounter = document.createElement('div');
      var lastLightboxIndex = Math.max(0, triggerIndex);
      var lightboxLabel = slider.getAttribute('aria-label') || trigger.getAttribute('aria-label');

      lightboxCounter.className = 'zen-home-v2-lightbox__counter';
      lightboxCounter.setAttribute('aria-live', 'polite');
      lightboxCounter.setAttribute('aria-atomic', 'true');
      lightboxCounter.textContent = (lastLightboxIndex + 1) + ' / ' + items.length;
      photoSwipeElement.classList.add('zen-home-v2-lightbox');
      photoSwipeElement.setAttribute('aria-modal', 'true');
      if (lightboxLabel) {
        photoSwipeElement.setAttribute('aria-label', lightboxLabel);
      }

      if (lightboxUi) {
        lightboxUi.appendChild(lightboxCounter);
      }

      var gallery = new window.PhotoSwipe(photoSwipeElement, window.PhotoSwipeUI_Default, items, {
        allowPanToNext: true,
        barsSize: { top: 24, bottom: 92 },
        bgOpacity: 1,
        captionEl: false,
        closeOnVerticalDrag: true,
        closeOnScroll: false,
        counterEl: false,
        fullscreenEl: false,
        history: false,
        hideAnimationDuration: shouldReduceMotion ? 1 : 180,
        index: Math.max(0, triggerIndex),
        loop: false,
        pinchToClose: true,
        preloaderEl: false,
        shareEl: false,
        showAnimationDuration: shouldReduceMotion ? 1 : 240,
        spacing: 0.08,
        tapToToggleControls: false,
        getThumbBoundsFn: function(index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var thumbnailRect = items[index].el.getBoundingClientRect();

          return {
            x: thumbnailRect.left,
            y: thumbnailRect.top + pageYScroll,
            w: thumbnailRect.width
          };
        }
      });

      gallery.listen('afterChange', function() {
        lastLightboxIndex = gallery.getCurrentIndex();
        lightboxCounter.textContent = (lastLightboxIndex + 1) + ' / ' + items.length;

        if (typeof setActive === 'function') {
          setActive(lastLightboxIndex);
        }
      });

      gallery.listen('destroy', function() {
        lightboxCounter.remove();

        var returnTrigger = lightboxTriggers[lastLightboxIndex] || trigger;
        window.setTimeout(function() {
          photoSwipeElement.classList.remove('zen-home-v2-lightbox');
          photoSwipeElement.removeAttribute('aria-modal');
          photoSwipeElement.removeAttribute('aria-label');
          returnTrigger.focus();
        }, 0);
      });
      gallery.init();
    };

    lightboxTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        if (event.defaultPrevented) {
          return;
        }

        openLightbox(trigger);
      });
    });

    if (!track || slides.length < 2 || notches.length < 2) {
      return;
    }

    var setActive = function(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));

      slides.forEach(function(slide, slideIndex) {
        var isActiveSlide = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActiveSlide);
        slide.setAttribute('aria-hidden', isActiveSlide ? 'false' : 'true');

        Array.prototype.slice.call(slide.querySelectorAll(focusableSelector)).forEach(function(focusable) {
          if (!focusable.hasAttribute('data-zen-home-v2-original-tabindex')) {
            focusable.setAttribute('data-zen-home-v2-original-tabindex', focusable.getAttribute('tabindex') || '');
          }

          if (isActiveSlide) {
            var originalTabindex = focusable.getAttribute('data-zen-home-v2-original-tabindex');
            if (originalTabindex === '') {
              focusable.removeAttribute('tabindex');
            } else {
              focusable.setAttribute('tabindex', originalTabindex);
            }
          } else {
            focusable.setAttribute('tabindex', '-1');
          }
        });
      });

      notches.forEach(function(notch, notchIndex) {
        var isActive = notchIndex === activeIndex;
        notch.classList.toggle('is-active', isActive);
        notch.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (status) {
        var activeLabel = notches[activeIndex] ? notches[activeIndex].getAttribute('aria-label') : '';
        status.textContent = activeLabel + ' (' + (activeIndex + 1) + ' of ' + slides.length + ')';
      }

      if (prevButton) {
        var isAtStart = activeIndex === 0;
        prevButton.disabled = isAtStart;
        prevButton.setAttribute('aria-disabled', isAtStart ? 'true' : 'false');
      }

      if (nextButton) {
        var isAtEnd = activeIndex === slides.length - 1;
        nextButton.disabled = isAtEnd;
        nextButton.setAttribute('aria-disabled', isAtEnd ? 'true' : 'false');
      }
    };

    var goTo = function(index) {
      setActive(index);
    };

    notches.forEach(function(notch, index) {
      notch.addEventListener('click', function() {
        goTo(index);
      });

      notch.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1);
          notches[activeIndex].focus();
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1);
          notches[activeIndex].focus();
        }
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        goTo(activeIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        goTo(activeIndex + 1);
      });
    }

    track.addEventListener('pointerdown', function(event) {
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      didHorizontalSwipe = false;
    });

    track.addEventListener('pointerup', function(event) {
      if (pointerStartX === null || pointerStartY === null) {
        return;
      }

      var distanceX = event.clientX - pointerStartX;
      var distanceY = event.clientY - pointerStartY;
      pointerStartX = null;
      pointerStartY = null;

      if (Math.abs(distanceX) < 34 || Math.abs(distanceX) < Math.abs(distanceY) * 1.2) {
        return;
      }

      didHorizontalSwipe = true;

      if (distanceX < 0) {
        goTo(activeIndex + 1);
      } else {
        goTo(activeIndex - 1);
      }
    });

    track.addEventListener('click', function(event) {
      if (!didHorizontalSwipe) {
        return;
      }

      event.preventDefault();
      didHorizontalSwipe = false;
    }, true);

    track.addEventListener('pointercancel', function() {
      pointerStartX = null;
      pointerStartY = null;
      didHorizontalSwipe = false;
    });

    setActive(0);
  });
})();
